import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { SectionWrapper } from '../components/ui/SectionWrapper';
import { Button } from '../components/ui/Button';
import { ArrowLeft, Clock, Calendar, User } from 'lucide-react';
import { guides, categories } from '../data/guides';
export function GuideDetailPage() {
  const {
    slug
  } = useParams();
  const guide = guides.find(g => g.id === slug);
  if (!guide) {
    return <SectionWrapper data-id="element-358">
        <div className="text-center py-20" data-id="element-359">
          <h1 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-360">
            Guide not found
          </h1>
          <Link to="/guides" data-id="element-361">
            <Button variant="primary" data-id="element-362">Back to Guides</Button>
          </Link>
        </div>
      </SectionWrapper>;
  }
  const category = categories.find(c => c.id === guide.category);
  return <article className="bg-white min-h-screen pb-20" data-id="element-363">
      <div className="border-b border-slate-100 bg-slate-50/50" data-id="element-364">
        <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-365">
          <Link to="/guides" className="inline-flex items-center text-sm text-slate-500 hover:text-teal-700 mb-6 transition-colors" data-id="element-366">
            <ArrowLeft className="w-4 h-4 mr-1" data-id="element-367" /> Back to Guides
          </Link>

          <div className="mb-6" data-id="element-368">
            <span className="inline-block px-3 py-1 bg-teal-50 text-teal-800 text-xs font-bold rounded-full uppercase tracking-wide border border-teal-100" data-id="element-369">
              {category?.label}
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-370">
            {guide.title}
          </h1>

          <div className="flex flex-wrap items-center gap-6 text-sm text-slate-500 border-t border-slate-200 pt-6" data-id="element-371">
            <div className="flex items-center" data-id="element-372">
              <User className="w-4 h-4 mr-2" data-id="element-373" />
              {guide.author}
            </div>
            <div className="flex items-center" data-id="element-374">
              <Calendar className="w-4 h-4 mr-2" data-id="element-375" />
              {guide.date}
            </div>
            <div className="flex items-center" data-id="element-376">
              <Clock className="w-4 h-4 mr-2" data-id="element-377" />
              {guide.readTime}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-378">
        <div className="prose prose-slate prose-lg max-w-none prose-headings:font-bold prose-headings:text-slate-900 prose-p:text-slate-600 prose-a:text-teal-700 hover:prose-a:text-teal-800" dangerouslySetInnerHTML={{
        __html: guide.content || ''
      }} data-id="element-379" />

        <div className="mt-16 pt-8 border-t border-slate-200" data-id="element-380">
          <h3 className="font-bold text-slate-900 mb-4" data-id="element-381">Related Categories</h3>
          <div className="flex gap-2" data-id="element-382">
            {categories.slice(0, 3).map(cat => <Link key={cat.id} to={`/category/${cat.id}`} data-id="element-383">
                <Button variant="outline" size="sm" data-id="element-384">
                  {cat.label}
                </Button>
              </Link>)}
          </div>
        </div>
      </div>
    </article>;
}